import RestService from '../services/rest';

async function getListAutomationProducts(limit, skip, search, orderBy, field) {
  return RestService.getAuthenticated(
    `panel/automationProducts/list?limit=${limit}&skip=${skip}&search=${search}&orderBy=${orderBy}&field=${field}`,
  );
}

async function getOptionsAutomationProduct(limit, search) {
  return RestService.getAuthenticated(`panel/automationProducts/options?limit=${limit}&search=${search}`);
}

async function getCsvAutomationProduct() {
  const response = await RestService.getAuthenticated('panel/automationProducts/csv/model', { responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'automation-products-modelo.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function createAutomationProducts(newAutomationProducts) {
  return RestService.postAuthenticated(
    'panel/automationProducts/create', newAutomationProducts,
  );
}

async function uploadCsvAutomationProduct(file) {
  const fd = new FormData();
  fd.append('file', file);
  return RestService.postAuthenticated('panel/automationProducts/csv/import', fd, {
    'Content-Type': 'multipart/form-data',
  });
}

async function updateAutomationProducts(updAutomationProducts) {
  return RestService.putAuthenticated(
    'panel/automationProducts/update', updAutomationProducts,
  );
}

export default {
  getListAutomationProducts,
  getOptionsAutomationProduct,
  createAutomationProducts,
  updateAutomationProducts,
  getCsvAutomationProduct,
  uploadCsvAutomationProduct,
};
